import defaultSettings from '../settings.json';
import type { LoginUser } from '@/services/auth';

export interface GlobalState {
  settings: typeof defaultSettings;
  user: LoginUser | null;
  userLoading: boolean;
  hydrated: boolean;
  sidebarCollapsed: boolean;
}

const initialState: GlobalState = {
  settings: defaultSettings,
  user: null,
  userLoading: false,
  hydrated: false,
  sidebarCollapsed: false,
};

type Action =
  | { type: 'update-user'; payload: { user: LoginUser | null; userLoading?: boolean } }
  | { type: 'set-hydrated'; payload: boolean }
  | { type: 'toggle-sidebar' }
  | { type: 'set-sidebar-collapsed'; payload: boolean };

export default function store(state = initialState, action: Action): GlobalState {
  switch (action.type) {
    case 'update-user':
      return {
        ...state,
        user: action.payload.user,
        userLoading: action.payload.userLoading ?? false,
      };
    case 'set-hydrated':
      return { ...state, hydrated: action.payload };
    case 'toggle-sidebar':
      return { ...state, sidebarCollapsed: !state.sidebarCollapsed };
    case 'set-sidebar-collapsed':
      return { ...state, sidebarCollapsed: action.payload };
    default:
      return state;
  }
}
